var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBarcodeQr = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    width: 42,
    height: 42,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "barcode qr") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "#9b9b9b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9b9b9b",
    d: "M11,11H0V0h11V11z M2,9h7V2H2V9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9b9b9b",
    d: "M24,11H13V0h11V11z M15,9h7V2h-7V9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9b9b9b",
    d: "M11,24H0V13h11V24z M2,22h7v-7H2V22z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9b9b9b",
    points: "24,20 22,20 22,15 20,15 20,18 14,18 14,13 16,13 16,16 18,16 18,13 24,13 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9b9b9b",
    points: "24,24 14,24 14,20 16,20 16,22 24,22 "
  }), /*#__PURE__*/React.createElement("rect", {
    "data-color": "color-2",
    x: 4,
    y: 4,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    "data-color": "color-2",
    x: 17,
    y: 4,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    "data-color": "color-2",
    x: 4,
    y: 17,
    width: 3,
    height: 3
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBarcodeQr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/barcode-qr.8ee4718c2b417ddbcac1b98ed58457d2.svg";